







import { mapActions } from 'vuex';
import SessionStorageService from '@/services/SessionStorageService';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';

export default {
  name: 'OidcCallbackError',
  methods: {
    ...mapActions('oidcStore', ['signOutOidc']),
    signout(this: any) {
      SessionStorageService.removeSessionId();
      this.signOutOidc();
    }
  },
  created(this: any) {
    this.SIGN_OUT_TIMEOUT_DURATION_IN_SECONDS = 1;
  },
  components: {
    LoadingSpinner
  }
};
